/**
 * Dashboard view mode — lets the owner see what everyone else sees.
 *
 * The owner account has surfaces nobody else does (Leads, Pipeline, the
 * commercial counters). That makes it the one account which cannot tell
 * whether a change looks right to an ordinary admin, because it never sees
 * the ordinary admin's dashboard.
 *
 * "User View" downgrades the owner's OWN view. It does not impersonate
 * anyone, read another account, or touch permissions — it only stops the
 * owner-only sections rendering, so the layout can be checked from the other
 * side. Any admin's real access is still decided server-side; this could not
 * grant anything even if it were abused, because it can only ever hide.
 *
 * Persisted, so the mode survives a reload and the owner does not silently
 * return to Super View mid-review.
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ViewMode = "super" | "user";

interface ViewModeState {
  mode: ViewMode;
  setMode: (mode: ViewMode) => void;
  toggle: () => void;
}

export const useViewModeStore = create<ViewModeState>()(
  persist(
    (set) => ({
      mode: "super",
      setMode: (mode) => set({ mode }),
      toggle: () => set((s) => ({ mode: s.mode === "super" ? "user" : "super" })),
    }),
    { name: "mppi-admin-view-mode" },
  ),
);
